import React from "react";
import { Agree } from "./checkoutUtils";

export const AgreementsSection = ({ form, setForm }) => (
  <section className="bg-white rounded-3xl border border-slate-200 p-7 shadow-sm">
    <h2 className="font-display text-xl font-bold text-knight-navy mb-5">Terms &amp; Privacy</h2>
    <div className="space-y-4 text-sm text-knight-navy/80">
      <Agree label='I accept the Terms of Service and understand the credit repair process. *' checked={form.agreeTerms} onCheck={v => setForm(f => ({ ...f, agreeTerms: v }))} />
      <Agree label='I accept the Privacy Policy and consent to data processing. *' checked={form.agreePrivacy} onCheck={v => setForm(f => ({ ...f, agreePrivacy: v }))} />
      <Agree label='I authorize Knight Credit Consultants to retry a failed payment once per billing cycle and to notify me by email or SMS. *' checked={form.agreeRetry} onCheck={v => setForm(f => ({ ...f, agreeRetry: v }))} />
      <Agree label="I'd like to receive occasional updates and tips about credit improvement. *" checked={form.promo} onCheck={v => setForm(f => ({ ...f, promo: v }))} />
    </div>
  </section>
);
